import { render, staticRenderFns } from "./SystemMessageDialog.vue?vue&type=template&id=57bd6358&scoped=true"
import script from "./SystemMessageDialog.vue?vue&type=script&lang=js"
export * from "./SystemMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./SystemMessageDialog.vue?vue&type=style&index=0&id=57bd6358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bd6358",
  null
  
)

export default component.exports